import { featureFlagClient } from '@trello/feature-flag-client';
import { forNamespace } from '@trello/i18n';

const format = forNamespace('butler');

/**
 * Returns the featureFlag evaluation i.e 'butler' or 'automation'
 * @return {string} butlerKey
 */
let butlerKey: string = '';
export function getButlerKey() {
  butlerKey =
    butlerKey ||
    featureFlagClient.getTrackedVariation(
      'workflowers.butler-rebrand',
      'not-enrolled',
    );

  if (butlerKey === 'not-enrolled') {
    return 'butler';
  }

  return butlerKey;
}

/**
 * Returns the localized name i.e 'Butler' or 'Automation'
 * @return {string}
 */
export function getButlerName() {
  return format(getButlerKey());
}

/**
 * Returns the appropriate icon for t.icon declaration in
 * board_menu_default.js.
 * @return {string}
 */
export function getButlerIconKey() {
  switch (getButlerKey()) {
    case 'automation':
      return 'automation';
    default:
      return 'butler-bot';
  }
}
